// Define the logit function
export function logit(...args) {
  if (typeof document === "undefined") {
    console.log(...args);
    return;
  }

  const logEntry = args
    .map((arg) =>
      typeof arg === "object" ? JSON.stringify(arg, null, 2) : String(arg)
    )
    .join(" ");

  // Check for the <pre> element with id "debuglog"
  const debugLogElement = document.getElementById("debuglog");
  if (debugLogElement) {
    // Append the log entry to the <pre> element
    debugLogElement.textContent += logEntry + "\n";
  } else {
    // Log to the console if the element is not present
    console.log(...args);
  }
}
